import React from 'react';
import{ useSelector, useDispatch } from 'react-redux';
import { Button, IconButton, List, Paper, Tooltip, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import TaskListItem from './TaskListItem';
import ITaskList from '../../types/tasks/ITaskList';

import * as taskActions from '../../actions/tasks';
import { selectTasks } from '../../reducers/tasks';
import { selectIsLoading } from '../../reducers/loading';
import ISubscribeTaskListRequest from '../../types/tasks/ISubscribeTaskListRequest';
import { isNull } from '../../utils/general';

const getTaskListsAction = taskActions.createGetTaskListsAction();
const subscribeTaskListAction = taskActions.createSubscribeTaskListAction();

const handleSave = (dispatch: any, checkedId: string, initialCheckedItem: ITaskList) => {
  const request = {
    SubscribeId: isNull(checkedId) ? null : checkedId,
    UnSubscribeId: initialCheckedItem?.Id,
  } as ISubscribeTaskListRequest;

  dispatch(subscribeTaskListAction(request));
}

const handleRefresh = (dispatch: any, timeout: number = 1000) => {
  // delay the dispatch to allow profile to be set
  setTimeout(() => dispatch(getTaskListsAction()), timeout);
}

export default () => {
  const [checkedId, setCheckedId] = React.useState(null);
  const taskLists = useSelector(selectTasks);
  const isLoading = useSelector(selectIsLoading);
  const dispatch = useDispatch();
  
  const initialCheckedItem = taskLists != null ? taskLists.find((item:ITaskList) => item.IsSubscribed) : null;

  React.useEffect(() => {
    handleRefresh(dispatch);
  }, []);

  React.useEffect(() => {

    if (!taskLists) {
      return;
    }

    if (initialCheckedItem) {
      setCheckedId(initialCheckedItem.Id);
    }
  }, [taskLists]);

  const handleCheck = (value: string) => () => setCheckedId(checkedId === value ? null : value);

  return (
    <React.Fragment>
      {!isLoading && (taskLists == null || taskLists.length === 0) && <Typography>Keine ToDo-Listen vorhanden.</Typography> }
      {taskLists != null && taskLists.length > 0 && (
        <React.Fragment>
          <Typography variant='h6' sx={{ mb: 1 }}>
            Bitte die ToDo-Liste auswählen, mit der die eigenen CRM-Aktivitäten synchronisiert werden soll.
            <Tooltip title='Aktualisieren' placement='right'>
							<IconButton onClick={() => handleRefresh(dispatch, 100)} size='small'><RefreshIcon color='primary'/></IconButton>
						</Tooltip>
          </Typography>
          <Typography variant='body2'>Es kann nur eine Liste ausgewählt werden für die Synchronisation.</Typography>
          <Typography variant='body2'>Um die Synchronisation wieder zu beenden, einfach die gewählte Liste abwählen und speichern.</Typography>
          <Paper sx={{ p: 2, mb: 2, mt: 2 }} elevation={2}>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
              {taskLists.map((item:ITaskList) => (
                  <TaskListItem key={item.Id} isLoading={isLoading} checkedId={checkedId} item={item} handleToggle={handleCheck} />
              ))}
            </List>
            <Button color='primary' disabled={
              (isNull(initialCheckedItem) && isNull(checkedId)) || 
              (!isNull(initialCheckedItem) && !isNull(checkedId) && initialCheckedItem?.Id === checkedId) ||
              isLoading} onClick={() => handleSave(dispatch, checkedId, initialCheckedItem)} variant='contained'>Speichern</Button>
          </Paper>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}